export const horizontalSmallDeviceBreakpoint = `@media (max-height: 500px)`;
